import React, { useState } from 'react';
import Card from '../components/Card';
import Button from '../components/Button';

export default function Security() {
  const [mfaEnabled, setMfaEnabled] = useState(true);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Security</h1>
        <p className="page-subtitle">Manage your account security settings</p>
      </div>

      <Card title="Change Password">
        <div style={{ maxWidth: '500px' }}>
          <div className="form-group">
            <label className="form-label">Current Password</label>
            <input type="password" className="form-input" placeholder="Enter current password" />
          </div>

          <div className="form-group">
            <label className="form-label">New Password</label>
            <input type="password" className="form-input" placeholder="Enter new password" />
          </div>

          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <input type="password" className="form-input" placeholder="Confirm new password" />
          </div>

          <Button>Update Password</Button>
        </div>
      </Card>

      <div style={{ marginTop: '24px' }}>
        <Card title="Two-Factor Authentication">
          <div style={{ padding: '20px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>
                  Status: {mfaEnabled ? (
                    <span className="badge success">✅ Enabled</span>
                  ) : (
                    <span className="badge warning">⏳ Disabled</span>
                  )}
                </div>
                <div style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                  {mfaEnabled ? 'Your account is protected with 2FA' : 'Enable 2FA for better security'}
                </div>
              </div>
              <Button variant={mfaEnabled ? 'danger' : 'primary'}>
                {mfaEnabled ? 'Disable 2FA' : 'Enable 2FA'}
              </Button>
            </div>

            {mfaEnabled && (
              <>
                <div style={{ marginTop: '24px', padding: '16px', background: 'var(--bg-tertiary)', borderRadius: '8px' }}>
                  <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
                    Authenticator App
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '600' }}>
                    Google Authenticator
                  </div>
                </div>

                <div style={{ marginTop: '16px', display: 'flex', gap: '12px' }}>
                  <Button variant="secondary">Show Backup Codes</Button>
                  <Button variant="secondary">Generate New Codes</Button>
                </div>
              </>
            )}
          </div>
        </Card>
      </div>

      <div style={{ marginTop: '24px' }}>
        <Card title="Active Sessions">
          <div className="table-container" style={{ marginTop: '20px' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Device</th>
                  <th>IP Address</th>
                  <th>Last Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>💻</span>
                      <span>Chrome on Windows</span>
                      <span className="badge info" style={{ marginLeft: '8px' }}>Current</span>
                    </div>
                  </td>
                  <td>192.168.1.100</td>
                  <td>Today at 8:47 PM</td>
                  <td>—</td>
                </tr>
                <tr>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>📱</span>
                      <span>Safari on iPhone</span>
                    </div>
                  </td>
                  <td>192.168.1.105</td>
                  <td>Today at 2:15 PM</td>
                  <td>
                    <button className="btn btn-danger" style={{ padding: '6px 12px', fontSize: '12px' }}>
                      Sign Out
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      <div style={{ marginTop: '24px' }}>
        <Card title="Danger Zone">
          <div style={{ padding: '20px 0' }}>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px', color: 'var(--red)' }}>
                Delete Account
              </div>
              <div style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                Once you delete your account, there is no going back. Please be certain.
              </div>
            </div>
            <Button variant="danger">Delete Account</Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
